import { COLUMN } from '@yme/atoms/grid/constants';
export const getColumnNumberForDesktop = (cardsLength, maxCards) => {
    if (cardsLength !== maxCards) {
        return COLUMN.lg / cardsLength;
    }
    return COLUMN.lg / 2;
};
